var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('busquedaAlumno'),_c('br'),(_vm.jsonAlumno.length == 0)?_c('div',{staticStyle:{"margin-bottom":"250px"}}):_vm._e(),(_vm.jsonAlumno.length != 0)?_c('alumnoComponet'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }